"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanetMessageType = void 0;
/**
 * Each message type has a corresponding entry here.
 */
exports.PlanetMessageType = {
    EmojiFlag: 'EmojiFlag',
};
